module.exports = __webpack_public_path__ + "static/media/2.IPhone_3G.6ede642e.png";